// src/features/dashboard/hooks/useProductivityChart.ts

import { useEffect, useState } from 'react';

import { ENV } from '../../../config/env';

import {
  mapProductivityChartData,
  productivityChartMockData,
} from '../mocks/productivityChart.mock';

import {
  getProductivityChart,
} from '../services/productivityChartApi';

import type {
  ProductivityChartItem,
} from '../types/productivityChart.types';

import {
  useManagerDate,
} from '../context/ManagerDateContext';

import {
  formatApiDate,
} from '../utils/date.utils';

export const useProductivityChart = (
  ManagerEmployeeCode?: string,
) => {

  const {
    fromDate,
    toDate,
  } = useManagerDate();

  const [chartData, setChartData] =
    useState<ProductivityChartItem[]>([]);

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState('');

  useEffect(() => {

    if (
      ManagerEmployeeCode == null ||
      Number.isNaN(
        ManagerEmployeeCode,
      )
    ) {
      return;
    }

    const loadChart =
      async () => {

        try {

          setLoading(true);
          setError('');

          /**
           * MOCK MODE
           */
          if (
            ENV.USE_MOCK
          ) {

            setChartData(
              mapProductivityChartData(
                productivityChartMockData,
              ),
            );

            return;
          }

          /**
           * API MODE
           */
          const payload = {
            ManagerEmployeeCode,

            fromDate:
              formatApiDate(
                fromDate,
              ),

            toDate:
              formatApiDate(
                toDate,
              ),
          };

          const response =
            await getProductivityChart(
              payload,
            );

          const apiArray =
            Array.isArray(
              response,
            )
              ? response
              : [];

          setChartData(
            mapProductivityChartData(
              apiArray,
            ),
          );

        } catch (err) {

          console.error(
            'Productivity chart error:',
            err,
          );

          setError(
            'Failed to load productivity chart',
          );

          setChartData([]);

        } finally {

          setLoading(false);
        }
      };

    loadChart();

  }, [
    ManagerEmployeeCode,
    fromDate,
    toDate,
  ]);

  return {
    chartData,
    loading,
    error,
  };
};